import { Stack, Typography } from "@mui/material";
import dico from "../../shared/util/src/language/dico";
import {
  entryDisplayValue,
  type EntryCell,
  type EntryReceipt,
} from "../../shared/util/src/athlete-entry";

/** Older receipts predate the retained-value field. Never confuse a refused proposal with it. */
export function retainedTicketValue(receipt: EntryReceipt, cell?: EntryCell) {
  if (receipt.retainedValue !== undefined)
    return entryDisplayValue(
      receipt.field,
      receipt.retainedValue,
      receipt.retainedValueLabel,
    );
  if (receipt.decision === "accepted")
    return entryDisplayValue(receipt.field, receipt.value, receipt.valueLabel);
  if (receipt.restoreApplied !== false)
    return entryDisplayValue(
      receipt.field,
      receipt.previousValue,
      receipt.previousValueLabel,
    );
  return entryDisplayValue(receipt.field, cell?.value);
}

export function ticketActivityTime(command: {
  receipt?: EntryReceipt;
  createdAt?: string;
}) {
  const receipt = command.receipt;
  const reviewed =
    receipt?.decision && receipt.reviewedAt
      ? Date.parse(receipt.reviewedAt)
      : 0;
  return Math.max(
    Number.isFinite(reviewed) ? Number(reviewed) : 0,
    receipt?.appliedAt || 0,
    command.createdAt && Number.isFinite(Date.parse(command.createdAt))
      ? Date.parse(command.createdAt)
      : 0,
  );
}

export default function TicketDecision({
  receipt,
  cell,
}: {
  receipt: EntryReceipt;
  cell?: EntryCell;
}) {
  const t = dico().athleteEntry;
  const unit = cell?.unit ?? (receipt.field.startsWith("custom:") ? "" : "kg");
  return (
    <Stack spacing={0.5} role="status" aria-live="polite">
      <Typography variant="body2" fontWeight={700}>
        {receipt.decision === "accepted"
          ? t.acceptedEntry
          : t.refusedBySecretary}
      </Typography>
      <Typography variant="body2">
        {receipt.label ||
          cell?.label ||
          (typeof t[receipt.field as keyof typeof t] === "string"
            ? (t[receipt.field as keyof typeof t] as string)
            : receipt.field)}
      </Typography>
      <Typography variant="body1" fontWeight={700}>
        {t.retainedValue} : {retainedTicketValue(receipt, cell)}
        {unit ? ` ${unit}` : ""}
      </Typography>
      {receipt.restoreApplied === false && (
        <Typography variant="body2">{t.refusedEntryManual}</Typography>
      )}
      {receipt.reviewNote && (
        <Typography variant="body2">{receipt.reviewNote}</Typography>
      )}
    </Stack>
  );
}
